module.exports = __webpack_public_path__ + "static/img/Reviews.92db928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Reviews.png
// module id = CDzW
// module chunks = 0